import agentReportCard from './agentReportCard';
import clientMetrics from './clientMetrics';
import leadFunnel from './leadFunnel';

export default {
  AgentReportCard: agentReportCard,
  ClientMetrics: clientMetrics,
  LeadFunnel: leadFunnel,
};
